module.exports = __webpack_public_path__ + "assets/img/2-5.cf923411.png";